import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Box, Button, Card } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ConfirmDelete from '../../../../shared/components/ConfirmDelete';
import CustomDataGrid from '../../../../shared/components/CustomDataGrid';
import { ERole } from '../../../../shared/enums/user/ERole';
import { useDepartment } from '../../../../shared/hooks/useDepartment';
import { useDepartmentUserColumns } from '../../../../shared/hooks/useDepartmentUserColumns';
import { IDepartment } from '../../../../shared/interfaces/department/IDepartment';
import { RootState } from '../../../../store/store';
import EmployeeFormModal from './EmployeeFormModal';
import EmployeeFormModalBody from './EmployeeFormModalBody';

const DepartmentUpdate = () => {
  const {
    department,
    setDepartment,
    selectedUser,
    setSelectedUserIds,
    selectedUserIds,
    closeDeleteModal,
    setSelectedUser,
    isAddModalOpened,
    setIsAddModalOpened,
    showDeleteModal,
    setShowDeleteModal,
    handleUpdateEmployees,
    deleteUserFromDepartmentHandler,
  } = useDepartment();
  const { userData } = useSelector((state: RootState) => state.auth);
  const isNormalUser = userData?.role === ERole.USER;
  const { t } = useTranslation();
  const columns = useDepartmentUserColumns(
    setSelectedUser,
    setShowDeleteModal,
    isNormalUser,
  );
  return (
    <Card>
      {!isNormalUser && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingBottom: '20px',
          }}
        >
          <Button
            variant={'contained'}
            onClick={() => {
              setIsAddModalOpened(true);
            }}
          >
            <AddCircleOutlineOutlinedIcon sx={{ marginRight: '5px' }} />
            {t('departments.updateDepartment', { name: department?.name })}
          </Button>
        </Box>
      )}
      <CustomDataGrid
        hideFooterPagination
        hasNextPage={false}
        rows={department?.users || []}
        columns={columns}
        rowCount={0}
        pagination={{ page: 0, perPage: 0 }}
        setPagination={() => {}}
        loading={department?.users === null}
      />

      <EmployeeFormModal
        isUpdate
        departmentName={department?.name}
        open={isAddModalOpened}
        handleClose={() => setIsAddModalOpened(false)}
        handleSubmit={handleUpdateEmployees}
      >
        <EmployeeFormModalBody
          department={department as IDepartment}
          setDepartment={setDepartment}
          setSelectedUserIds={setSelectedUserIds}
          selectedUserIds={selectedUserIds}
        />
      </EmployeeFormModal>
      <ConfirmDelete
        open={showDeleteModal}
        title={`${selectedUser?.firstName} ${selectedUser?.lastName}`}
        handleClose={closeDeleteModal}
        handleSubmit={() =>
          deleteUserFromDepartmentHandler(department?.id, selectedUser?.id)
        }
      />
    </Card>
  );
};

export default DepartmentUpdate;
